<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">バックリンク</li>
            </ol>
        </nav>
        <div class="container p-0">
            <div class="text-muted small p-2 my-3">
                スポンサーサイト、登録サーチなどへのバックリンク設定です。<br>
                バナーと共に登録することで、本棚トップページに表示されます。
                <div class="text-danger">
                    宣伝目的のリンク集になっていた場合、無警告でアカウントが停止されます。
                </div>
            </div>
            <div class="d-flex justify-content-between mb-3">
                <div>
                    <button type="button" class="btn btn-outline-success" @click="saveSort()" v-if="isSorted">
                        <i class="fas fa-sort-alpha-down"></i>
                        順番更新
                    </button>
                    <button type="button" class="btn btn-outline-secondary" @click="load()" v-if="isSorted">
                        <i class="fas fa-redo-alt"></i>
                        順番変更キャンセル
                    </button>
                </div>
                <div>
                    <button type="button" class="btn btn-outline-primary" :disabled="backlinks && backlinks.length >= $store.state.max_backlink" @click="showBacklink()">
                        <i class="fas fa-plus"></i>
                        新規バックリンク追加
                    </button>
                </div>
            </div>
            <div class="card my-2" v-for="(v, i) in backlinks" :key="v.id">
                <div class="card-body">
                    <div class="d-flex flex-wrap flex-lg-nowrap justify-content-between">
                        <div>
                            <h5 class="card-title">
                                <img :src="'/img/search/' + searchBanner(v.url)" class="img-thumbnail link-img mb-2" v-if="searchBanner(v.url)">
                                <img :src="v.picture.url + '?' + v.picture.hash" class="img-thumbnail img-link" v-else-if="v.picture">
                                <span class="handle">{{v.link_name}}</span>
                            </h5>
                            <p class="card-text small">
                                <a :href="v.url" target="_blank">
                                    {{v.url}}
                                </a>
                            </p>
                        </div>
                        <div class="pt-5">
                            <button type="button" class="btn btn-link" @click="select(v.id)" v-if="backlinks.length > 1">
                                <i class="fas fa-sort" v-if="!selected"></i>
                                <i class="fas fa-sort-up" v-else-if="i < selectedIndex"></i>
                                <i class="fas fa-sort-down" v-else-if="i > selectedIndex"></i>
                                <i class="fas fa-times" v-else></i>
                                <span v-if="!selected">移動</span>
                                <span v-else-if="i < selectedIndex">この上に移動</span>
                                <span v-else-if="i > selectedIndex">この下に移動</span>
                                <span v-else>移動をキャンセル</span>
                            </button>
                            <button type="button" class="btn btn-link" @click="showBacklink(v.id)">
                                <i class="fas fa-edit"></i>
                                編集
                            </button>
                            <button type="button" class="btn btn-link text-danger" @click="remove(v)">
                                <i class="fas fa-times"></i>
                                削除
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nothing" v-if="!backlinks || !backlinks.length">
                バックリンクがありません。<br>
                新規にバックリンクを追加してください。
            </div>
        </div>
        <backlink
            :backlink_id="backlink_id"
            @saved="load()"></backlink>
    </div>
</template>

<script>
import backlink from "./backlink.vue";
import searchServices from "@/searchServices";
export default {
    components: {
        backlink
    },
    data() {
        return {
            backlinks: [],
            backlink_id: null,
            selected: null,
            sorted: null,
            searches: searchServices,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/backlinks/backlinks").then(res => {
                this.backlinks = res.data;
            }).catch(err => { alert.err(err) });
        },
        showBacklink(id = null) {
            this.backlink_id = id;
            setTimeout(() => {$("#backlink-modal").modal()});
        },
        saveSort() {
            axios.post("/mypage/backlinks/save-sort", {backlinks: this.backlinks}).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        remove(v) {
            Swal.fire({
                title: "バックリンク削除",
                html: `<div class="text-left">
                    指定のバックリンクを削除します。<br>
                    よろしいですか？
                    </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/backlinks/remove", {'id': v.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => {
                        alert.err(err.response);
                    });
                }
            });
        },
        searchBanner(url) {
            for (const domain in this.searches) {
                const regex = new RegExp(domain, "i");
                if (url.match(regex)) {
                    return this.searches[domain].banner;
                }
            }
            return null;
        },
        select(id) {
            if (!this.selected) {
                // 選択
                this.selected = id;
                this.sorted = id;
            } else if (this.selected === id) {
                // 選択解除
                this.selected = null;
                this.sorted = null;
            } else {
                // 並び替え
                const from = this.selectedIndex;
                const dest = _.findIndex(this.backlinks, {id: id});     // fromを抜く前のindex
                const src = this.backlinks.splice(from, 1);
                const to = _.findIndex(this.backlinks, {id: id});       // fromを抜いた後のindex
                if (from < dest) {
                    // 下がる
                    this.backlinks.splice(to + 1, 0, src[0]);
                } else {
                    // 上がる
                    this.backlinks.splice(to, 0, src[0]);
                }
                this.sorted = this.selected;
                this.selected = null;
            }
        },
    },
    computed: {
        isSorted() {
            for (let i = 0; i < this.backlinks.length; i++) {
                if (this.backlinks[i].order_number != (i + 1)) {
                    return true;
                }
            }
            return false;
        },
        selectedIndex() {
            return _.findIndex(this.backlinks, {id: this.selected});
        },
    },
    mounted() {
        this.load();
    }
}
</script>